const showCreatorsPopupContainer = () => {
  const creatorsPopupContainer = document.getElementById('creators-popup-container');
  creatorsPopupContainer.style.display = 'flex';
}

const hideCreatorsPopupContainer = () => {
  const creatorsPopupContainer = document.getElementById('creators-popup-container');
  creatorsPopupContainer.style.display = 'none';
}

const openCreatorsPopupStartConversation = () => {
  const creatorsPopupStartConversation = document.getElementById('creators-popup-start-conversation');
  creatorsPopupStartConversation.style.display = 'flex';

  closeCreatorsPopupApply();
  showCreatorsPopupContainer();
}

const closeCreatorsPopupStartConversation = () => {
  const creatorsPopupStartConversation = document.getElementById('creators-popup-start-conversation');
  creatorsPopupStartConversation.style.display = 'none';

  hideCreatorsPopupContainer();
}

const openCreatorsPopupApply = () => {
  const creatorsPopupApply = document.getElementById('creators-popup-apply');
  creatorsPopupApply.style.display = 'flex';

  closeCreatorsPopupStartConversation();
  showCreatorsPopupContainer();
}

const closeCreatorsPopupApply = () => {
  const creatorsPopupApply = document.getElementById('creators-popup-apply');
  creatorsPopupApply.style.display = 'none';

  hideCreatorsPopupContainer();
}

window.addEventListener('DOMContentLoaded', () => {
  const creatorsPopupContainer = document.getElementById('creators-popup-container');

  creatorsPopupContainer.addEventListener('click', hideCreatorsPopupContainer);

  const creatorsPopupStartConversation = document.getElementById('creators-popup-start-conversation');
  const creatorsPopupApply = document.getElementById('creators-popup-apply');

  const creatorsPopupStartConversationCloseButton = document.getElementById('creators-popup-start-conversation-close-button');
  const creatorsPopupApplyCloseButton = document.getElementById('creators-popup-apply-close-button');

  creatorsPopupStartConversation.addEventListener('click', (e) => e.stopPropagation());
  creatorsPopupApply.addEventListener('click', (e) => e.stopPropagation());

  creatorsPopupStartConversationCloseButton.addEventListener('click', closeCreatorsPopupStartConversation);
  creatorsPopupApplyCloseButton.addEventListener('click', closeCreatorsPopupApply);
});
